import React from 'react';
import {
  IdentityBox,
  InnerBox,
  SectionTitle,
  InfoSection,
  InfoItem,
  Label,
  Value,
  ImageSection,
  IdImageFrame,
  IdImage,
  IdImagePlaceholder,
  PendingBadge,
  PendingHint,
} from './ManageBox.style';
import { useImageLightbox } from '../../Feedback/ImageLightbox';

interface ManageBoxProps {
  displayName: string;
  nationalId: string;
  nationalIdImage: string;
  /**
   * A replacement uploaded against a verified identity, waiting for review.
   * Shown in place of the live image with a badge, so the publisher can see
   * their upload registered; the live one stays what the reviewer verified.
   */
  pendingNationalIdImage?: string;
  name: string;
  identityType: string;
}

const ManageBox: React.FC<ManageBoxProps> = ({
  displayName,
  nationalId,
  nationalIdImage,
  pendingNationalIdImage = '',
  name,
  identityType,
}) => {
  // A company files a شناسه ملی and an official letterhead introduction; the
  // personal wording below belongs only to a حقیقی publisher.
  const lightbox = useImageLightbox();
  const isLegal = identityType === 'LEGAL';
  const idLabel = isLegal ? 'شناسه ملی' : 'کد ملی';
  const imageLabel = isLegal
    ? 'تصویر معرفی نامه شرکت با سربرگ رسمی'
    : 'عکس کارت ملی';

  return (
    <IdentityBox>
      <InnerBox>
        <SectionTitle>اطلاعات هویتی</SectionTitle>

        <InfoSection>
          <InfoItem>
            <Label>نام کاربری</Label>
            <Value>{name}</Value>
          </InfoItem>
          <InfoItem>
            <Label>نام و نام خانوادگی</Label>
            <Value>{displayName}</Value>
          </InfoItem>
        </InfoSection>
        <InfoItem>
          <Label>{idLabel}</Label>
          <Value>{nationalId || '—'}</Value>
        </InfoItem>
        <ImageSection>
          <Label>{imageLabel}</Label>
          {pendingNationalIdImage ? (
            <>
              <IdImageFrame>
                <IdImage
                  src={pendingNationalIdImage}
                  alt={`${imageLabel} (در انتظار بررسی)`}
                  {...lightbox.triggerProps(
                    pendingNationalIdImage,
                    `${imageLabel} (در انتظار بررسی)`,
                  )}
                />
                <PendingBadge>در انتظار بررسی</PendingBadge>
              </IdImageFrame>
              {nationalIdImage && (
                <PendingHint>
                  تا زمان تایید، تصویر قبلی معتبر است.{' '}
                  <span
                    {...lightbox.triggerProps(nationalIdImage, imageLabel)}
                  >
                    مشاهده تصویر فعلی
                  </span>
                </PendingHint>
              )}
            </>
          ) : nationalIdImage ? (
            <IdImageFrame>
              <IdImage
                src={nationalIdImage}
                alt={imageLabel}
                {...lightbox.triggerProps(nationalIdImage, imageLabel)}
              />
            </IdImageFrame>
          ) : (
            <IdImagePlaceholder>
              هنوز تصویری ثبت نشده است. از بخش ویرایش اطلاعات آن را بارگذاری
              کنید.
            </IdImagePlaceholder>
          )}
        </ImageSection>
      </InnerBox>
      {lightbox.element}
    </IdentityBox>
  );
};

export default ManageBox;
